import type {
  CatalogListOptions,
  CatalogPage,
  CatalogRepository,
} from '#/domain/catalog/CatalogRepository'
import type { CatalogLayer } from '#/domain/catalog/CatalogLayer'

export class GetLayerByOrgIdUseCase {
  constructor(private readonly repository: CatalogRepository) {}

  async execute(
    organizationId: string,
    options: CatalogListOptions,
  ): Promise<CatalogPage<CatalogLayer>> {
    return this.repository.findLayersByOrganizationId(organizationId, options)
  }
}
